import { AddUserIcon, CategoryIcon, GiftIcon, TaskListEditIcon } from '@/assets/icons';
import type { QuickActionConfig } from '../model';

/**
 * Конфигурация пунктов быстрого меню (2×2 сетка по нажатию +)
 */
export const QUICK_ACTIONS: QuickActionConfig[] = [
  {
    id: 'friend',
    icon: AddUserIcon,
    title: 'navigation:bottomMenu.quickActions.findFriend',
  },
  {
    id: 'secret-santa',
    icon: GiftIcon,
    title: 'navigation:bottomMenu.quickActions.secretSanta',
  },
  {
    id: 'wishlist',
    icon: CategoryIcon,
    title: 'navigation:bottomMenu.quickActions.addWishlist',
  },
  {
    id: 'wish',
    icon: TaskListEditIcon,
    title: 'navigation:bottomMenu.quickActions.addWish',
  },
];